import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import { dragAndDropStyle, thumbStyle } from "../../../../theme/theme";
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { getImageFileType } from "../../../../utils/utils";

export default function SummaryAnchor(props) {
    const [open, setOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const { thumb, thumbInner, img } = thumbStyle();
    const { url, title, fileSize, type } = props;
    const { xs, sm, md, lg, xl } = props.sizes;

    const {
        uploadedFileIcon
    } = dragAndDropStyle();

    const linkStyle = {
        cursor: "pointer"
    }

    const modal = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }

    const handleToggle = () => {
        setOpen(!open);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpenModal = () => {
        setOpenModal(true);
    };
    const handleCloseModal = () => {
        setOpenModal(false);
    };

    return (
        <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
            <div
                id="file-thumb"
                className={`${thumb}`}
                style={{
                    position: "relative",
                    zIndex: 1
                }}
                onMouseEnter={handleToggle}
                onMouseLeave={handleClose}
            >
                <div className={thumbInner}>
                    {getImageFileType(type)
                      ? <img src={url} className={img} alt={title} />
                      : <PictureAsPdfIcon style={uploadedFileIcon} />
                    }
                </div>
                {!getImageFileType(type) ? null :
                     <Backdrop
                          onClick={(e) => {
                              e.preventDefault();
                              handleOpenModal();
                          }}
                          style={{
                            position: "absolute",
                            zIndex: 2,
                            cursor: "pointer"
                          }}
                          open={open}
                      >
                          <OpenInNewOutlinedIcon style={{ ...uploadedFileIcon, color: "#fff" }} />
                      </Backdrop>
                }
            </div>
            <Link
                href={url}
                style={linkStyle}
                target="_blank"
                rel="noopener noreferrer"
                variant="body2"
            >
                {title}
            </Link>
            <h4 style={{ fontWeight: "normal" }}>
                {fileSize}
            </h4>
            <Modal
                style={modal}
                open={openModal}
                onClose={handleCloseModal}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                    style: {
                        backgroundColor: "transparent",
                    },
                }}
            >
                <Fade in={openModal}>
                    <img
                        src={url}
                        style={{
                            width: "300px",
                            height: "auto",
                            outline: "none",
                            border: "2px solid #EAEFF2",
                            borderRadius: 2,
                        }}
                        alt={title}
                    />
                </Fade>
            </Modal>
        </Grid >
    );
}
